// Dependencies
import React, { Component } from 'react';
import RegistrationFormStepTitleComponent from '../form-step-title/form-step-title';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './step-10.scss';

// Utils
import { getFormValue } from '../../../common/utils/form-utils';
import { getCVTypeList, isCVTypeUrl } from '../../../common/lists/other';
import { Button } from 'primereact/button';

// Redux
import { connect } from 'react-redux';
import { updateFormStep, updateStep10State } from '../../../redux/actions/form';
import { FORM_FIELD_CV_TYPE, FORM_FIELD_CV_URL, FORM_STEP_10_STATE, REGISTRATION_STATE_REVISION, STEP_STATE_SUBMITTED, STEP_STATE_VALIDATION_ERROR } from '../../../common/constants';

class RegistrationFormStep10Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cvType: { key: FORM_FIELD_CV_TYPE, value: null },
            cvUrl: { key: FORM_FIELD_CV_URL, value: "" },
            // Validation flags
            validCvType: true,
            validCvUrl: true
        }
    }

    componentDidMount() {
        this.setState({
            cvType: getFormValue(FORM_FIELD_CV_TYPE, this.props.formFields),
            cvUrl: getFormValue(FORM_FIELD_CV_URL, this.props.formFields),
        });
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: { key: column, value: value }
        });
    }

    validateForm() {
        let validationResult = true;

        if(isCVTypeUrl(this.state.cvType)) {
            this.setState({
                validCvType: true,
                validCvUrl: this.state.cvUrl !== "",
                //validCvFile: true
            });

            validationResult = (this.state.cvUrl !== "");
        }
        else {
            this.setState({
                //validCvFile: this.state.cvDoc === null ? this.state.cvAttachment !== null : true,
                validCvType: this.state.cvType !== null,
                validCvUrl: true
            });

            validationResult = this.state.cvType !== null; //this.state.cvDoc === null ? this.state.cvAttachment !== null : true;
        }

        return validationResult;
    }

    submitStep() {
        if(this.validateForm()) {
            this.props.updateStep10State(STEP_STATE_SUBMITTED);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_FIELD_CV_TYPE, value: this.state.cvType },
                    { key: FORM_FIELD_CV_URL, value: this.state.cvUrl },
                    { key: FORM_STEP_10_STATE, value: STEP_STATE_SUBMITTED }
                ],
                () => this.props.onNext());
        }
        else {
            this.props.updateStep10State(STEP_STATE_VALIDATION_ERROR);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_10_STATE, value: STEP_STATE_VALIDATION_ERROR }
                ],
                () => {});
        }
    }

    render() {
        return (
            <>
                <div id="data-container" className="card p-fluid mgt-20">
                    <div className="grid">
                        <div className="col-12">
                            <div className="grid mgt-10">
                                <RegistrationFormStepTitleComponent title={this.props.t("registration-form.step-10.title")}
                                                                    subtitles={[ this.props.t("registration-form.step-10.subtitle-1"), this.props.t("registration-form.step-10.subtitle-2") ]} />
                                <div className='col-12 t-align-left mgt-10'>
                                    <label htmlFor="cvType">{this.props.t("profile.areas.qualification.areas.cv.cv-type")} <span className="invalid-message">*</span></label>
                                    <Dropdown id="cvType" value={this.state.cvType.value} options={getCVTypeList(getLanguage())} optionLabel="name" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} onChange={(evt) => this.updateFormComponent("cvType", evt.value)}></Dropdown>
                                    { this.state.validCvType ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                </div>
                                {
                                    isCVTypeUrl(this.state.cvType) ?
                                        <div className='col-12 t-align-left'>
                                            <label htmlFor="cvUrl">{this.props.t("profile.areas.qualification.areas.cv.cv-url")} <span className="invalid-message">*</span></label>
                                            <InputText id="cvUrl" value={this.state.cvUrl.value} type="text" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} onChange={(evt) => this.updateFormComponent("cvUrl", evt.value)}/>
                                            { this.state.validCvUrl ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        : null
                                }
                                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                                    <FileUpload mode="basic" 
                                                accept="application/pdf" 
                                                chooseLabel="Curriculum Vitae (.PDF) "
                                                maxFileSize={1000000} 
                                                //uploadHandler={(evt) => this.uploadDocumentHandler(evt.files)} customUpload={true} auto={true}
                                                onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                    {
                                        this.state.cvAttachment !== null ? 
                                            <span>{this.state.cvAttachmentName}</span> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION ?
                        <div className="mgt-20">
                            <div className="grid">
                                <div className="col-4 t-align-left mgt-10">
                                    <Button label={this.props.t("general.back")} severity="info" raised outlined onClick={(evt) => this.props.onBack()} />
                                </div> 
                                <div className="col-4 t-align-center mgt-10">
                                    <Button icon="pi pi-question-circle" severity='success' label="Verificar passo 10" raised />
                                </div> 
                                <div className="col-4 t-align-right mgt-10">
                                    <Button label={this.props.t("general.next")} severity="info" raised outlined onClick={(evt) => this.props.onNext()} />
                                </div> 
                            </div>
                        </div>
                        : null
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registrationState: state.authentication.registrationState,
        formFields: state.form.formFields,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep10State: (state) => { dispatch(updateStep10State(state)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationFormStep10Component));